import { useState, useEffect } from "react";
import { supabase } from "../lib/supabaseClient";
import { useToast } from "../ToastContext";

export default function NotificationsSettings({ user }) {
  const { addToast } = useToast();
  const [settings, setSettings] = useState({ notify_email: user?.email || "", global_notify: false });
  const [qrs, setQrs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    if (!user?.id) return;
    supabase.from("qr_codes").select("id, name, notify_on_lead, notify_email").eq("user_id", user.id)
      .order("created_at", { ascending: false })
      .then(({ data }) => { setQrs(data || []); setLoading(false); });
  }, [user?.id]);

  const toggleNotify = async (qrId, currentVal) => {
    setSaving(qrId);
    await supabase.from("qr_codes").update({
      notify_on_lead: !currentVal,
      notify_email: settings.notify_email
    }).eq("id", qrId);
    setQrs(prev => prev.map(q => q.id === qrId ? { ...q, notify_on_lead: !currentVal } : q));
    addToast(!currentVal ? "Notifications enabled" : "Notifications disabled", "success");
    setSaving(null);
  };

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-black text-white uppercase italic tracking-tighter">Scan Notifications</h1>
        <p className="text-gray-500 text-[10px] uppercase tracking-widest mt-1">Get notified when leads are captured</p>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-6 space-y-4">
        <p className="text-[10px] font-black uppercase text-gray-500 tracking-widest">Notification Email</p>
        <div className="flex gap-3">
          <input
            type="email"
            value={settings.notify_email}
            onChange={e => setSettings({ ...settings, notify_email: e.target.value })}
            className="flex-1 bg-white/5 border border-white/10 rounded-xl p-3 text-white text-sm outline-none focus:border-blue-500"
            placeholder="email@example.com"
          />
          <button
            onClick={() => addToast("Email saved", "success")}
            className="px-4 py-3 bg-blue-600 rounded-xl text-[10px] font-black uppercase text-white"
          >
            Save
          </button>
        </div>
        <p className="text-[9px] text-gray-600">Note: Email delivery requires Resend or SendGrid integration. Currently logs to console.</p>
      </div>

      {loading ? (
        <div className="flex justify-center p-10">
          <div className="w-6 h-6 border-2 border-red-500 border-t-transparent rounded-full animate-spin" />
        </div>
      ) : (
        <div className="bg-white/5 border border-white/10 rounded-[32px] overflow-hidden">
          <div className="p-6 border-b border-white/10">
            <h3 className="text-sm font-black uppercase tracking-widest">QR Code Notifications</h3>
          </div>
          <div className="divide-y divide-white/5">
            {qrs.length === 0 ? (
              <p className="p-6 text-gray-500 text-sm">No QR codes found.</p>
            ) : qrs.map(qr => (
              <div key={qr.id} className="flex items-center justify-between px-6 py-4">
                <div>
                  <p className="text-white text-sm font-black">{qr.name || "Untitled"}</p>
                  <p className="text-gray-500 text-[10px] uppercase">{qr.notify_on_lead ? "Notifications ON" : "Notifications OFF"}</p>
                </div>
                <button
                  onClick={() => toggleNotify(qr.id, qr.notify_on_lead)}
                  disabled={saving === qr.id}
                  className={`w-12 h-6 rounded-full transition-all relative ${qr.notify_on_lead ? "bg-green-500" : "bg-white/10"}`}
                >
                  <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${qr.notify_on_lead ? "left-7" : "left-1"}`} />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}